import { lazy } from 'react'

export const LicenseFileLinkModalAsync = lazy(() => import('./LicenseFileLinkModal')
    .then((module) => ({ default: module.LicenseFileLinkModal }))
)
